<div [formGroup]="originForm" class="origin-criteria-details">
    <div class="row">
        <div class="col-9">
            <bds-origin-select-box
                formControlName="originCode"
                [returnCity]="returnCity"
                [returnState]="returnState"
            ></bds-origin-select-box>
        </div>
        <div class="col-3">
            <mat-form-field
                floatLabel="always"
                class="w-100"
                appearance="fill"
                [class.bds-mat-dense-form-field]="dense"
            >
                <mat-label>Origin Delivery Hrs</mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="originDeliveryHours"
                    min="0"
                    max="999"
                />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <mat-form-field
                floatLabel="always"
                class="w-100"
                [ngClass]="{
                    'bds-readonly-wrapper': !isClone && !isNew,
                    'bds-mat-dense-form-field': dense
                }"
                appearance="fill"
            >
                <mat-label>Sight Code</mat-label>
                <mat-select formControlName="sightCode">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let item of sightCodes" [value]="item.id">
                        {{ item.id }} - {{ item.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <bds-railroad-select
                formControlName="railroad"
                label="Railroad"
                class="bds-readonly-wrapper"
            ></bds-railroad-select>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <mat-form-field
                floatLabel="always"
                class="w-100"
                [ngClass]="{
                    'bds-readonly-wrapper': !(isNew || isClone),
                    'bds-mat-dense-form-field': dense
                }"
                appearance="fill"
            >
                <mat-label>Location City</mat-label>
                <input
                    matInput
                    bdsShoutcase
                    formControlName="locationCity"
                    [readonly]="!(isNew || isClone)"
                    class="text-uppercase"
                />
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field
                floatLabel="always"
                class="w-100"
                [ngClass]="{
                    'bds-readonly-wrapper': !isClone && !isNew,
                    'bds-mat-dense-form-field': dense
                }"
                appearance="fill"
            >
                <mat-label>State</mat-label>
                <mat-select formControlName="locationState">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let item of states" [value]="item.code">
                        {{ item.code }} - {{ item.description }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
